<script>
export default {
  data() {
    return {
      interval: null,
      aliveTime: 3000,
    };
  },
  computed: {
    notifications: {
      get() {
        return this.$store.state.notifications.notifications;
      },
      set(value) {
        this.$store.dispatch('nt_update_notifications', value);
      },
    },
  },
  created() {
    this.interval = setInterval(this.clearMessage, 1000);
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
  methods: {
    clearMessage() {
      const current = new Date().getTime() - this.aliveTime;

      this.notifications = this.notifications.filter((item) => (item.created > current) || (item.type === 'error'));
    },
    remove(key) {
      this.notifications.splice(key, 1);
    },
  },
};
</script>
<template src="./notifications.pug" lang="pug"></template>
<style src="./notifications.styl" lang="stylus"></style>
